import { tradegwApi } from '../request'
import { apiPath } from '../api'

export const delivery = {
  getDeliveryDetail: data => tradegwApi.post(apiPath.deliveryDetail, data),
  getWaybillList: data => tradegwApi.post(apiPath.getWaybillList, data),
  getDeliveryVoucher: data => tradegwApi.post(apiPath.getDeliveryVoucher, data)
}
